import Vue from "vue";
import VueRouter from "vue-router";

import HomePage from "./components/Pages/Home";
import IceCreamPage from "./components/Pages/IceCream";
import HomeyPage from "./components/Pages/Homey";
import CheesecakesPage from "./components/Pages/Cheesecakes";
import ChezbiPage from "./components/Pages/Chezbi";
import ChocolatePage from "./components/Pages/Chocolate";
import MolonezPage from "./components/Pages/Molonez";
import RisovashkiPage from "./components/Pages/Risovashki";
import CondensedMilkPage from "./components/Pages/CondensedMilk";
import HistoryPage from "./components/Pages/History";
import NewsPage from "./components/Pages/News";
import NotFoundPage from "./components/Pages/NotFound";
import VacanciesvggPage from "./components/Pages/Vacanciesvgg";
import VacanciestdrennaPage from "./components/Pages/Vacanciestdrenna";
import VacanciesPage from "./components/Pages/Vacancies";
import VacanciesrhPage from "./components/Pages/Vacanciesrh";
import VacancieslogPage from "./components/Pages/Vacancieslog";
import VacanciesdistPage from "./components/Pages/Vacanciesdist";
import VacanciesamkkPage from "./components/Pages/Vacanciesamkk";
import VacanciessovPage from "./components/Pages/Vacanciessov";
import VacancieskmkkPage from "./components/Pages/Vacancieskmkk";
import VacanciesfnmPage from "./components/Pages/Vacanciesfnm";
import VacanciesliderPage from "./components/Pages/Vacancieslider";

import SitesPage from "./components/Pages/Sites";

import SideCenter from "./components/SideCenter";
import SideVacancies from "./components/SideVacancies";

import ZakupkiPage from "./components/Pages/Zakupki";
import ContactsPage from "./components/Pages/Contacts";

Vue.use(VueRouter);

export default new VueRouter({
    mode: "history",
    routes: [

        {name: "home", path: "/", component: HomePage},

        {name: "ice-cream", path: "/ice-cream.html", components: {
                default: IceCreamPage,
                "side-center": SideCenter
            }},
        {name: "homey", path: "/homey.html", components: {
                default: HomeyPage,
                "side-center": SideCenter
            }},
        {name: "cheesecakes", path: "/cheesecakes.html", components: {
                default: CheesecakesPage,
                "side-center": SideCenter
            }},
        {name: "chezbi", path: "/chezbi.html", components: {
                default: ChezbiPage,
                "side-center": SideCenter
            }},
        {name: "chocolate", path: "/chocolate.html", components: {
                default: ChocolatePage,
                "side-center": SideCenter
            }},
        {name: "molonez", path: "/molonez.html", components: {
                default: MolonezPage,
                "side-center": SideCenter
            }},
        {name: "risovashki", path: "/risovashki.html", components: {
                default: RisovashkiPage,
                "side-center": SideCenter
            }},
        {name: "condensed-milk", path: "/condensed-milk.html", components: {
                default: CondensedMilkPage,
                "side-center": SideCenter
            }},

        {name: "sites", path: "/sites.html", component: SitesPage},

        {name: "vacancies", path: "/vacancies.html", component: VacanciesPage},

            {name: "vacanciestd", path: "/vacanciestd.html", components: {
                default: VacanciestdrennaPage,
                "side-center": SideVacancies
            }},

            {name: "vacanciesvgg", path: "/vacanciesvgg.html", components: {
                default: VacanciesvggPage,
                "side-center": SideVacancies
            }},

            
            {name: "vacanciesrh", path: "/vacanciesrh.html", components: {
                default: VacanciesrhPage,
                "side-center": SideVacancies
            }},

            {name: "vacancieslog", path: "/vacancieslog.html", components: {
                default: VacancieslogPage,
                "side-center": SideVacancies
            }},

            {name: "vacanciesdist", path: "/vacanciesdist.html", components: {
                default: VacanciesdistPage,
                "side-center": SideVacancies
            }},

            {name: "vacanciesamkk", path: "/vacanciesamkk.html", components: {
                default: VacanciesamkkPage,
                "side-center": SideVacancies
            }},

            {name: "vacanciessov", path: "/vacanciessov.html", components: {
                default: VacanciessovPage,
                "side-center": SideVacancies
            }},

            {name: "vacancieskmkk", path: "/vacancieskmkk.html", components: {
                default: VacancieskmkkPage,
                "side-center": SideVacancies
            }},

            {name: "vacanciesfnm", path: "/vacanciesfnm.html", components: {
                default: VacanciesfnmPage,
                "side-center": SideVacancies
            }},

            {name: "vacancieslider", path: "/vacancieslider.html", components: {
                default: VacanciesliderPage,
                "side-center": SideVacancies
            }},



        {name: "history", path: "/history.html", component: HistoryPage},
        {name: "zakupki", path: "/zakupki.html", component: ZakupkiPage},
        {name: "contacts", path: "/contacts.html", component: ContactsPage},
        {name: "news", path: "/news-:id.html", component: NewsPage, props: true},
        {path: "*", component: NotFoundPage}
    ]
});